import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

import { tooltipText } from '../../../utils/studentstats'

export default class StudentStat extends Component {
  constructor(props) {
    super(props)
    this.onHoverBound = this.onHover.bind(this)
    this.state = { hover: false }
  }
  render() {
    const { type, hasNoCompletedQuests } = this.props
    return (
      <div className="user-stat">
        <ReactTooltip
          id={`${type}-tooltip`}
          effect="solid"
          offset={{ bottom: 10 }}
        />
        <div className={`icon ${type} ${this.state.hover ? 'hover' : ''}`} />
        <div
          className="stat-value"
          onMouseEnter={this.onHoverBound}
          onMouseLeave={this.onHoverBound}
          data-for={`${type}-tooltip`}
          data-tip={tooltipText[type]}
        >
          {hasNoCompletedQuests && this.props.formatEmptyWithNA
            ? 'N/A'
            : this.props.value}
        </div>
      </div>
    )
  }

  onHover() {
    this.setState(prevState => {
      return {
        hover: !prevState.hover
      }
    })
  }
}

StudentStat.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasNoCompletedQuests: PropTypes.bool.isRequired,
  formatEmptyWithNA: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/quest/studentstats/StudentStat.js